import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.element.classList.add("flash-highlight")
        this.timeout = setTimeout(() => {
            this.element.classList.remove("flash-highlight")
        }, 2000)
    }
    disconnect() { clearTimeout(this.timeout) }
}